module.exports = __webpack_public_path__ + "static/img/AA.d577355f.png";